"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillableRequestSchemaProperties = exports.BillableRequestSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const billing_rate_schema_1 = require("./billing-rate-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
const BillableRequestStatus = zod_1.z.enum(["submitted", "rejected", "approved"]);
const BillableRequestHistoryEntry = zod_1.z.object({
    accountId: zod_1.z.string(),
    status: BillableRequestStatus,
    reason: zod_1.z.string().optional(),
    date: zod_1.z.date(),
});
exports.BillableRequestSchema = base_schema_1.BaseSchema.extend({
    billingRate: billing_rate_schema_1.BillingRateSchema,
    accountId: zod_1.z.string(),
    date: zod_1.z.date(),
    status: BillableRequestStatus,
    statusHistory: zod_1.z.array(BillableRequestHistoryEntry),
    clientId: zod_1.z.string().optional(),
    duration: zod_1.z.number(),
    description: zod_1.z.string().optional(),
    paidAt: zod_1.z.date().optional(),
});
const BillableRequestClient = zod_1.z.object({
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    email: zod_1.z.string(),
    id: zod_1.z.string(),
});
exports.BillableRequestSchemaProperties = {
    collectionName: "billableRequests",
    deleteMode: schema_properties_interface_1.DeleteMode.Soft,
};
//# sourceMappingURL=billable-request-schema.js.map